export const ADD_PRODUCT = 8
export const EDIT_PRODUCT = 9
export const DELETE_PRODUCT = 10
export const ADD_CATEGORY = 11
export const EDIT_CATEGORY = 12
export const DELETE_CATEGORY = 13
export const ADD_SUPPLIER = 14
export const EDIT_SUPPLIER = 15
export const DELETE_SUPPLIER = 16
export const ADD_METRIC = 17
export const EDIT_METRIC = 18
export const DELETE_METRIC = 19
export const VIEW_PRODUCTS_LIST = 67
export const EXPORT_PRODUCTS_LIST = 68
export const VIEW_SUPPLIER_LIST = 69
export const EXPORT_SUPPLIER_LIST = 70
export const VIEW_CATEGORY_LIST = 71
export const EXPORT_CATEGORY_LIST = 72
export const VIEW_PRODUCT_METRIC_LIST = 73
export const EXPORT_PRODUCT_METRIC_LIST = 74
